export default __webpack_public_path__ + "static/media/users-invite.929dac46.png";